import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { Partner } from '../../../partner/models/partner';
import { PartnerStateService } from '../../../partner/services/partner-state.service';
import { PartnerCodeTransaction } from '../../models/partner-code-transaction';
import { PartnerCodeInfoStepService } from '../../services/partner-code-info-step.service';
import { PartnerCodeStateService } from '../../services/partner-code-state.service';
import { PartnerCodeService } from '../../services/partner-code.service';

@Component({
  selector: 'app-partner-code-profile-info',
  templateUrl: './partner-code-profile-info.component.html',
  styleUrls: ['./partner-code-profile-info.component.css']
})
export class PartnerCodeProfileInfoComponent implements OnInit {

  private _transactions: PartnerCodeTransaction[];

  constructor(
    private router: Router,
    private partnerCodeService: PartnerCodeService,
    private partnerStateService: PartnerStateService,
    private shopSettingsService: ShopSettingsService,
    private partnerCodeInfoStepService: PartnerCodeInfoStepService,
  ) {
  }

  ngOnInit(): void {
    this.partnerCodeService.getPartnerCodeTransactions()
      .subscribe((transactions: PartnerCodeTransaction[]) => {
        this._transactions = transactions;
      });
  }

  get transactions(): PartnerCodeTransaction[] {
    return this._transactions;
  }

  get partner(): Partner {
    return this.partnerStateService.loggedInPartner;
  }

  formatMoneyText(amount: number): string {
    return environment.globalSettings.toMoneyStr(amount);
  }

  get isVUMode(): boolean {
    return this.shopSettingsService.isVUMode;
  }

  onBack(): void {
    this.partnerCodeInfoStepService.back();
  }

  get showTransactionList(): boolean {
    return !!this.partner && !!this.transactions?.length;
  }

  onHomeClick(): void {
    this.router.navigateByUrl('');
  }

}
